import React  from 'react';
import TabContainer from '../../../../../../../common/components/tab/containers/tab.containers';
import LeadBasicInfoComponent from './lead-basic-info.component';

export const LeadComponent = ({ leadDetails,getCategoryName,back}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Lead Information',
        component:<LeadBasicInfoComponent 
        leadDetails={leadDetails}
        getCategoryName={getCategoryName}
        />,
    isVisible:true,
    },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
        </div>
       </div>
  )
}
export default LeadComponent;
